import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Loader from "../../components/common/Loader";
import { useSelector } from "react-redux";
import apiLink from "../../api/apiLink";
import { resellerThirdPartyPayment } from "../../features/getIspOwnerUsersApi";
import useISPowner from "../../hooks/useISPOwner";

import BKashLogo from "../../assets/logo/bKash.png";
import SSLCommerzLogo from "../../assets/logo/sslCommerz.png";
import UddoktaPayLogo from "../../assets/logo/uddoktaPay.png";
import ShurjoPayLogo from "../../assets/logo/shurjoPay.png";

const ResellerOnlinePayment = ({ show, setShow }) => {
  const { t } = useTranslation();

  //---> Get user & current user data form useISPOwner hooks
  const { ispOwnerData } = useISPowner();

  // reseller data
  const resellerData = useSelector(
    (state) => state.persistedReducer.auth?.userData
  );

  // payment amount state
  const [paymentAmount, setPaymentAmount] = useState("");

  // customer agreement state
  const [agreement, setAgreement] = useState(false);

  //Loading state
  const [isLoading, setIsLoading] = useState(false);

  // user data state
  const [userData, setUserData] = useState(null);

  // user data setState
  useEffect(() => {
    if (resellerData) {
      setUserData(resellerData);
    }
  }, [resellerData]);

  const billPaymentController = async (medium) => {
    const data = {
      amount: paymentAmount,
      ispOwner: userData.ispOwner,
      reseller: userData.id,
      medium: medium,
    };

    resellerThirdPartyPayment(data, setIsLoading);
  };

  // modal close handler
  const handleClose = () => setShow(false);

  const bKash = window.bkash;

  let URL = {
    create: "reseller/bkash-create-recharge",
    execute: "reseller/bkash-execute-recharge",
    baseURL: apiLink,
  };

  useEffect(() => {
    let paymentID = "";
    if (userData) {
      bKash.init({
        paymentMode: "checkout", //fixed value ‘checkout’
        paymentRequest: {
          amount: paymentAmount,
          merchantInvoiceNumber: Date.now(),
          intent: "sale",
          ispOwner: userData.ispOwner,
          reseller: userData.id,
        },
        createRequest: async function (request) {
          try {
            const { data } = await URL.baseURL.post(URL.create, request);
            if (data?.statusCode === "0000") {
              localStorage.setItem("paymentAmount", paymentAmount);
              sessionStorage.setItem("qrispid", userData.ispOwner);
              window.location.href = data?.bkashURL;
            }

            if (data?.paymentID) {
              paymentID = data.paymentID;
              bKash.create().onSuccess(data);
            } else {
              bKash.create().onError();
              window.location.href = "/payment/failed";
            }
          } catch (error) {
            bKash.create().onError();
            window.location.href = "/payment/failed";
            console.log(error);
          }
        },
        executeRequestOnAuthorization: async function () {
          const resellerRechargeData = {
            amount: paymentAmount,
            reseller: userData.id,
            ispOwner: userData.ispOwner,
          };
          try {
            const { data } = await URL.baseURL.post(
              `${URL.execute}?paymentID=${paymentID}&reseller=${userData.id}`,
              resellerRechargeData
            );
            if (data.resellerRecharge.paymentStatus === "paid") {
              window.location.href = "/payment/success";
            } else {
              window.location.href = "/payment/failed";
              bKash.execute().onError();
            }
          } catch (error) {
            bKash.execute().onError();
            window.location.href = "/payment/failed";
            console.log(error);
          }
        },
      });
    }
  }, [userData, paymentAmount]);

  const getGridStyle = (count) => {
    if (count >= 4) {
      return {
        gridTemplateColumns: "repeat(4, 1fr)",
      };
    }

    return {
      gridTemplateColumns: `repeat(${count}, 1fr)`,
      justifyContent: "center",
    };
  };

  const paymentGateway = ispOwnerData?.bpSettings?.paymentGateway;
  const paymentMethods = [
    {
      id: "bKash_button",
      title: "bKashPG",
      logo: BKashLogo,
      trigger: () => {},
      isVisible: paymentGateway?.providers?.bKash,
    },
    {
      title: "sslcommerz",
      logo: SSLCommerzLogo,
      trigger: () => billPaymentController("sslcommerz"),
      isVisible: paymentGateway?.providers?.sslCommerz,
    },
    {
      title: "uddoktapay",
      logo: UddoktaPayLogo,
      trigger: () => billPaymentController("uddoktapay"),
      isVisible: paymentGateway?.providers?.uddoktaPay,
    },
    {
      title: "shurjoPay",
      logo: ShurjoPayLogo,
      trigger: () => billPaymentController("shurjoPay"),
      isVisible: paymentGateway?.providers?.shurjoPay,
    },
  ];

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <ModalHeader closeButton>
        <ModalTitle>
          <h5 className="modal-title text-black">{t("paymentAmount")}</h5>
        </ModalTitle>
      </ModalHeader>
      <ModalBody>
        <div className="displayGrid">
          <input
            onChange={(e) => setPaymentAmount(e.target.value)}
            className="form-control "
            type="number"
            placeholder={t("enterYourAmount")}
          />

          <div
            className="displayGrid4"
            style={getGridStyle(
              paymentMethods.filter((item) => item.isVisible)?.length
            )}
          >
            {paymentMethods?.map(
              (method) =>
                method.isVisible && (
                  <button
                    key={method.title}
                    id={method?.id ? method.id : ""}
                    type="button"
                    className="payment-card bg-white"
                    onClick={method.trigger}
                  >
                    <img
                      src={method.logo}
                      alt={method.title}
                      className="payment-logo"
                    />
                  </button>
                )
            )}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ResellerOnlinePayment;
